import * as React from 'react';
export const IcEthernetOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.2}
      d='M7.713 7.289a.996.996 0 00-1.41 0l-4.01 4a.996.996 0 000 1.41l4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-3.29-3.29 3.29-3.29a.996.996 0 000-1.41v-.01zm14 4l-4-4a.996.996 0 10-1.41 1.41l3.29 3.29-3.29 3.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l4-4a.996.996 0 000-1.41l-.01.01z'
      fill='currentColor'
    />
    <path
      d='M13.25 16.17c-.16-.25-.4-.44-.67-.55-.27-.11-.58-.14-.87-.09-.29.06-.56.2-.77.41-.21.21-.35.48-.41.77-.06.29-.03.59.09.87s.31.51.55.67A1.499 1.499 0 0013.5 17c0-.3-.09-.59-.25-.83zM12 13.5c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71v-6c0-.27-.11-.52-.29-.71A.99.99 0 0012 5.5c-.27 0-.52.11-.71.29a.99.99 0 00-.29.71v6c0 .27.11.52.29.71.18.19.44.29.71.29z'
      fill='currentColor'
    />
  </svg>
);
